/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    view: {
        'class': 'process-item',
        $html: [{
            'class':'icon',
            $html:{
                tag:'i',
                'class':['iconfont',nb.bind('icon')]
            }
        },{
            'class':'text',
            $text:nb.bind('text')
        },{
            'class':'desc',
            $html:nb.bind('desc')
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/register/Item.js
// module id = 534
// module chunks = 6